




























































































import Vue, { PropType } from "vue";
import { ValidationProvider, extend } from "vee-validate";
// types
import { Publisher } from "@/features/coreWebVitals/types";

extend("httpFormat", {
  validate(value) {
    const httpRegex = new RegExp(/^((http|https):\/\/)/);
    return httpRegex.test(value);
  },
});

extend("dotFormat", {
  validate(value) {
    const dotRegex = new RegExp(/.*(?!.*\.).+$/);
    return dotRegex.test(value);
  },
});

extend("emojiSyntax", {
  validate(value) {
    const emojiRegex = new RegExp(require("emoji-regex"));
    return !emojiRegex.test(value);
  },
});

export default Vue.extend({
  components: {
    "validation-provider": ValidationProvider,
  },

  props: {
    domainNameInput: { type: String, required: true },
    publishers: {
      type: Array as PropType<Publisher[]>,
      required: true,
    },
    publisherInput: {
      type: Number,
      required: true,
    },
    clickSave: { type: Function as PropType<() => void>, required: true },
    clickCancel: { type: Function as PropType<() => void>, required: true },
    loading: { type: Boolean, required: true },
  },
  computed: {
    localDomainNameInput: {
      get(): string {
        return (this as any).domainNameInput;
      },
      set(val: string) {
        return (this as any).$emit("update:domainNameInput", val);
      },
    },
    localPublisherInput: {
      get(): Publisher {
        return (this as any).publisherInput;
      },
      set(val: Publisher) {
        return (this as any).$emit("update:publisherInput", val);
      },
    },
  },
});
